<form
  [formGroup]="form"
  class="document-form bg-neutrals-0 grid grid-flow-row rounded-[8px] p-3 box-border gap-4"
  (submit)="onSubmit()"
>
  <div
    class="flex"
    [ngClass]="{
      'justify-center items-center': verticalContainer,
      'justify-start': !verticalContainer,
    }"
  >
    <ui-paragraph
      type="p12"
      mobile-type="p12"
      text-color="neutrals-700"
      font-weight="semibold"
    >
      Producto nuevo
    </ui-paragraph>
  </div>

  <div
    [ngClass]="{
      'grid grid-flow-row gap-4': verticalContainer,
      'flex gap-1': !verticalContainer,
    }"
  >
    <!-- Select businessLineId Field (solo si NO viene pre-configurado) -->
    <div class="flex flex-col gap-1" *ngIf="!initialBusinessLineId">
      <div
        class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
        [ngClass]="{
          error: getErrorState('businessLineId'),
        }"
        #businessLineIdContainer
      >
        <ui-icon
          name="tag"
          size="16"
          mSize="16"
          [fill]="getFormIconColor('businessLineId')"
        />
        <select
          formControlName="businessLineId"
          (focus)="businessLineIdContainer.classList.add('focussed')"
          (blur)="businessLineIdContainer.classList.remove('focussed')"
          (change)="onBusinessLineId($event)"
        >
          <option value="">Seleccionar unidad de negocio</option>
          <option
            *ngFor="let businessLine of businessLines"
            [value]="businessLine.id"
          >
            {{ businessLine.name }}
          </option>
        </select>
      </div>
      <ui-paragraph
        class="px-1 box-border"
        type="p10"
        mobile-type="p10"
        text-color="critical-300"
        font-weight="regular"
        *ngIf="getErrorState('businessLineId')"
      >
        La unidad de negocio es obligatoria.
      </ui-paragraph>
    </div>

    <!-- Select productId Field -->
    <div class="flex flex-col gap-1">
      <div
        class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
        [ngClass]="{
          error: getErrorState('productId'),
        }"
        #productIdContainer
      >
        <ui-icon
          name="group"
          size="16"
          mSize="16"
          [fill]="getFormIconColor('productId')"
        />
        <select
          formControlName="productId"
          (focus)="productIdContainer.classList.add('focussed')"
          (blur)="productIdContainer.classList.remove('focussed')"
          (change)="onProductId($event)"
        >
          <option value="">Seleccionar producto</option>
          <option *ngFor="let product of products" [value]="product.id">
            {{ product.name }}
          </option>
        </select>
      </div>
      <ui-paragraph
        class="px-1 box-border"
        type="p10"
        mobile-type="p10"
        text-color="critical-300"
        font-weight="regular"
        *ngIf="getErrorState('productId')"
      >
        El producto es obligatorio.
      </ui-paragraph>
    </div>

    <!-- Select productVariantId Field (Standard Mode) -->
    <div class="flex flex-col gap-1" *ngIf="!isCustomProductMode">
      <div
        class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
        [ngClass]="{
          error: getErrorState('productVariantId'),
        }"
        #productVariantIdContainer
      >
        <ui-icon
          name="group"
          size="16"
          mSize="16"
          [fill]="getFormIconColor('productVariantId')"
        />
        <select
          formControlName="productVariantId"
          (focus)="productVariantIdContainer.classList.add('focussed')"
          (blur)="productVariantIdContainer.classList.remove('focussed')"
        >
          <option value="">Seleccionar variante</option>
          <option *ngFor="let variant of variants" [value]="variant.id">
            {{ variant.name }}
          </option>
        </select>
      </div>
      <ui-paragraph
        class="px-1 box-border"
        type="p10"
        mobile-type="p10"
        text-color="critical-300"
        font-weight="regular"
        *ngIf="getErrorState('productVariantId')"
      >
        La variante es obligatoria.
      </ui-paragraph>
    </div>

    <!-- Custom Product Configuration (Custom Mode) -->
    <div
      *ngIf="isCustomProductMode"
      class="custom-config-section flex flex-col gap-4"
    >
      <ui-paragraph
        type="p12"
        mobile-type="p12"
        text-color="neutrals-700"
        font-weight="semibold"
      >
        Configuración personalizada
      </ui-paragraph>

      <!-- Cemento -->
      <div class="flex flex-col gap-1">
        <div
          class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
          #cementContainer
        >
          <ui-icon name="group" size="16" mSize="16" fill="neutrals-900" />
          <select
            [(ngModel)]="customSelection.cementId"
            [ngModelOptions]="{ standalone: true }"
            (focus)="cementContainer.classList.add('focussed')"
            (blur)="cementContainer.classList.remove('focussed')"
            (change)="onCustomAttributeChange('cementId')"
          >
            <option [value]="null">Seleccionar cemento</option>
            <option
              *ngFor="let option of customConfigOptions?.cement"
              [value]="option.id"
            >
              {{ option.displayName }}
            </option>
          </select>
        </div>
      </div>

      <!-- Resistencia -->
      <div class="flex flex-col gap-1">
        <div
          class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
          [ngClass]="{ disabled: !customSelection.cementId }"
          #resistanceContainer
        >
          <ui-icon name="group" size="16" mSize="16" fill="neutrals-900" />
          <select
            [(ngModel)]="customSelection.resistanceId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="!customSelection.cementId"
            (focus)="resistanceContainer.classList.add('focussed')"
            (blur)="resistanceContainer.classList.remove('focussed')"
            (change)="onCustomAttributeChange('resistanceId')"
          >
            <option [value]="null">Seleccionar resistencia</option>
            <option
              *ngFor="let option of customConfigOptions?.resistance"
              [value]="option.id"
            >
              {{ option.displayName }}
            </option>
          </select>
        </div>
      </div>

      <!-- Aditivo -->
      <div class="flex flex-col gap-1">
        <div
          class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
          [ngClass]="{ disabled: !customSelection.resistanceId }"
          #additiveContainer
        >
          <ui-icon name="group" size="16" mSize="16" fill="neutrals-900" />
          <select
            [(ngModel)]="customSelection.additiveId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="!customSelection.resistanceId"
            (focus)="additiveContainer.classList.add('focussed')"
            (blur)="additiveContainer.classList.remove('focussed')"
            (change)="onCustomAttributeChange('additiveId')"
          >
            <option [value]="null">Seleccionar aditivo</option>
            <option
              *ngFor="let option of customConfigOptions?.additive"
              [value]="option.id"
            >
              {{ option.displayName }}
            </option>
          </select>
        </div>
      </div>

      <!-- Piedra -->
      <div class="flex flex-col gap-1">
        <div
          class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
          [ngClass]="{ disabled: !customSelection.additiveId }"
          #stoneContainer
        >
          <ui-icon name="group" size="16" mSize="16" fill="neutrals-900" />
          <select
            [(ngModel)]="customSelection.stoneId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="!customSelection.additiveId"
            (focus)="stoneContainer.classList.add('focussed')"
            (blur)="stoneContainer.classList.remove('focussed')"
            (change)="onCustomAttributeChange('stoneId')"
          >
            <option [value]="null">Seleccionar piedra</option>
            <option
              *ngFor="let option of customConfigOptions?.stone"
              [value]="option.id"
            >
              {{ option.displayName }}
            </option>
          </select>
        </div>
      </div>

      <!-- Slump -->
      <div class="flex flex-col gap-1">
        <div
          class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
          [ngClass]="{ disabled: !customSelection.stoneId }"
          #slumpContainer
        >
          <ui-icon name="group" size="16" mSize="16" fill="neutrals-900" />
          <select
            [(ngModel)]="customSelection.slumpId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="!customSelection.stoneId"
            (focus)="slumpContainer.classList.add('focussed')"
            (blur)="slumpContainer.classList.remove('focussed')"
            (change)="onCustomAttributeChange('slumpId')"
          >
            <option [value]="null">Seleccionar slump</option>
            <option
              *ngFor="let option of customConfigOptions?.slump"
              [value]="option.id"
            >
              {{ option.displayName }}
            </option>
          </select>
        </div>
      </div>

      <!-- Validation Messages -->
      <div
        *ngIf="isValidatingCustom"
        class="validation-loading flex items-center gap-2 px-3 py-2"
      >
        <ui-loader size="small" color="primary-700" />
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          text-color="neutrals-700"
          font-weight="regular"
        >
          Validando combinación...
        </ui-paragraph>
      </div>

      <div
        *ngIf="customValidationError"
        class="validation-error px-3 py-2 rounded-[8px]"
      >
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          text-color="critical-300"
          font-weight="regular"
        >
          {{ customValidationError }}
        </ui-paragraph>
      </div>

      <div
        *ngIf="validatedVariant && !customValidationError"
        class="validation-success px-3 py-2 rounded-[8px]"
      >
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          text-color="success-300"
          font-weight="regular"
        >
          ✓ Producto válido: {{ validatedVariant.name }}
        </ui-paragraph>
      </div>
    </div>

    <!-- Select quantity Field -->
    <div class="flex flex-col gap-1">
      <div
        class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
        [ngClass]="{
          error: getErrorState('quantity'),
        }"
        #quantityContainer
      >
        <ui-icon
          name="box"
          size="16"
          mSize="16"
          [fill]="getFormIconColor('quantity')"
        />
        <input
          type="text"
          placeholder="Cantidad"
          uniconDecimalFormatter
          formControlName="quantity"
          (focus)="quantityContainer.classList.add('focussed')"
          (blur)="quantityContainer.classList.remove('focussed')"
        />
      </div>
      <ui-paragraph
        class="px-1 box-border"
        type="p10"
        mobile-type="p10"
        text-color="critical-300"
        font-weight="regular"
        *ngIf="getErrorState('quantity')"
      >
        La cantidad es obligatoria.
      </ui-paragraph>
    </div>
  </div>

  <div
    class="grid gap-2"
    [ngClass]="{ 'grid-flow-col': !initialBusinessLineId }"
  >
    <button
      *ngIf="!initialBusinessLineId"
      class="btn-cancel"
      type="button"
      (click)="cancel.emit()"
    >
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        text-color="neutrals-900"
        font-weight="semibold"
      >
        Cancelar
      </ui-paragraph>
    </button>
    <button class="btn-submit" type="submit" [disabled]="!isFormValid()">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        [textColor]="isFormValid() ? 'primary-700' : 'neutrals-0'"
        font-weight="semibold"
      >
        Agregar
      </ui-paragraph>
    </button>
  </div>
</form>
